import { useDispatch, useSelector } from "react-redux";
import {
  addCustomer,
  addIntervention,
  addLedgerAccoount,
  addNote,
  addOrderType,
  addPatientIndication,
  addPayment,
  addStoreWallet,
  addTable,
  resetCheckoutInfo,
  updateCurrentPaymentInfo,
} from "../store/modules/checkoutInfo";

export const useCheckoutHelper = () => {
  const dispatch = useDispatch();
  const {
    customer,
    payment,
    store_wallet,
    table,
    order_type,
    order_note,
    intervention,
    indication,
    ledger_account_id,
  } = useSelector((state) => state?.checkoutReducer);
  const { allow_ledger_account } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  const setCustomerInfo = (data) => {
    dispatch(addCustomer(data));
  };

  const setOrderType = (data) => {
    dispatch(addOrderType(data));
  };

  const setIntervention = (data) => {
    dispatch(addIntervention(data));
  };

  const setIndication = (data) => {
    dispatch(addPatientIndication(data));
  };

  const setOrderNote = (data) => {
    dispatch(addNote(data));
  };

  const setTable = (data) => {
    dispatch(addTable(data));
  };

  const setLedgerAccount = (data) => {
    dispatch(addLedgerAccoount(data));
  };

  const setPaymentMethod = (data) => {
    dispatch(addPayment(data));
  };

  const setStoreWallet = (data) => {
    dispatch(addStoreWallet(data));
  };

  const updatePayment = (data) => {
    dispatch(updateCurrentPaymentInfo(data));
  };

  const resetCheckoutView = () => {
    dispatch(resetCheckoutInfo());
  };

  return {
    customer,
    payment,
    store_wallet,
    table,
    order_type,
    order_note,
    ledger_account_id,
    allow_ledger_account,
    intervention,
    indication,
    setIntervention,
    setIndication,
    setLedgerAccount,
    setTable,
    setOrderNote,
    setCustomerInfo,
    setOrderType,
    setPaymentMethod,
    setStoreWallet,
    updatePayment,
    resetCheckoutView,
  };
};
